// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"4ca83893","402":"8f61bb68","568":"43560c9f","727":"b9d78150","821":"ac5be0bb"}[chunkId] + ".chunk.js";
};